import {fetchNewsItems} from './fetchNewsItems';

const newscategoriesCheckBoxes = [].slice.call(document.getElementsByName('newscategories')) as Array<HTMLInputElement>;
const newspaginationlinkButton = [].slice.call(document.getElementsByName('newspaginationlink')) as Array<HTMLInputElement>;
const newsCategory = [].slice.call(document.getElementsByName('newscategoriesparentnode')) as HTMLElement;
const newsSortBy:HTMLSelectElement = <HTMLSelectElement>document.getElementById('sort_news');
const resetnewscategories:HTMLSelectElement = <HTMLSelectElement>document.getElementById('resetnewscategories');
const newssearchButton:HTMLElement = <HTMLElement>document.getElementById('newssearchButton');
const contentsearchButton:HTMLElement = <HTMLElement>document.getElementById('contentsearchButton');
const contentsearchButtonMobile:HTMLElement = <HTMLInputElement>document.getElementById('contentsearchButton-mobile');
const newsclearButton:HTMLElement = <HTMLElement>document.getElementsByClassName('news-term-clear')[0];
const newsterm:HTMLInputElement = <HTMLInputElement>document.getElementById('newsterm');
const prevbtn:HTMLInputElement = <HTMLInputElement>document.getElementsByClassName("directory-pagination-button-news-prev")[0];
const nextbtn:HTMLInputElement = <HTMLInputElement>document.getElementsByClassName("directory-pagination-button-news-next")[0];
const contentsearchtext:HTMLInputElement = <HTMLInputElement>document.getElementById('contentsearch');
const contentsearchtextmobile:HTMLInputElement = <HTMLInputElement>document.getElementById('contentsearch-mobile') ;
const listingpageurl:HTMLInputElement = <HTMLInputElement>document.getElementById('listingpageurl');
let newstermstring:string = "";
let newsid: string = "";
let terms: Array<string> = [];
let termsstring:string = "";
let newssort: string = newsSortBy ? newsSortBy.value : 'newest';
let currentpage: number = 1;
let totalPage: number = 1;

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const q = urlParams.get('q');
const decodedQueryString = decodeURIComponent(queryString);
const category = decodedQueryString.indexOf('category') > -1 ? decodedQueryString.substring(decodedQueryString.indexOf('=')+1) : null;

if (newsCategory[0])
{
    const newsCategoryIndex = newsCategory[0].id.indexOf('_');
    newsid =  newsCategory[0].id.substring(newsCategoryIndex+1);   
}

if (newsSortBy) 
{
    newsSortBy.addEventListener('change', (e) => {
        const value = (<HTMLSelectElement>(e.target)).selectedOptions[0].value;
        newssort = value;
        fetchNewsItems(newsid, terms.join('|'), newssort, currentpage, newstermstring);
    });
}

if (newsterm && q)
{
    newstermstring = q;
    fetchNewsItems(newsid, '', newssort, currentpage, q).then(() => {
        if (q.indexOf('|') > -1)
        {
            newsterm.value = q.substring(0,q.indexOf('|'));
            if (window.location.search.indexOf('?') > -1)
            {
                const cleanurl = `${window.location.href.split("?")[0]}?q=${newsterm.value}`;
                window.history.replaceState({}, document.title, cleanurl);
            }
        }
        else
        {
            newsterm.value = q;
        }
    });
}

if (newsterm && category)
{
    terms = [category];
    fetchNewsItems(newsid, terms.join(), newssort, currentpage, '');
    if (newscategoriesCheckBoxes)
    {
        newscategoriesCheckBoxes.forEach(checkbox => {
            if (checkbox.value === category)
            {
                checkbox.checked = true;
                const groupDiv = checkbox.closest('div'); 
                if (groupDiv) {
                    const id = groupDiv.getAttribute('id');
                    const groupButton = document.querySelector(`[aria-controls="${id}"]`);
                    if (groupButton)
                    {
                        if (groupButton.getAttribute('aria-expanded') == 'false')
                        {
                            groupButton.setAttribute('aria-expanded','true');
                            groupDiv.setAttribute('aria-hidden','false');
                        }
                    }
                }
            }
        });
    }
    const parentGroup = document.getElementById(category);
    if (parentGroup)
    {
        const ckb = [].slice.call(parentGroup.querySelectorAll("input[type=checkbox]")) as Array<HTMLInputElement>;
        terms = [];
        ckb.forEach( el => {
            el.checked = true;
            terms.push(el.value);
        });
        if (newsCategory[0])
        {
            newsCategory[0].setAttribute("data-terms", terms.join('|'));
        }
        const parentButton = document.querySelector(`[aria-controls="${category}"]`);
        if (parentButton && parentButton.getAttribute('aria-expanded') == 'false')
        {
            parentButton.setAttribute('aria-expanded','true');
            parentGroup.setAttribute('aria-hidden','false');
        }
    }
    if (window.location.search.indexOf('?') > -1)
    {
        const cleanurl = window.location.href.split("?")[0];
        window.history.replaceState({}, document.title, cleanurl);
    }
}

if (newsclearButton) {
    newsclearButton.addEventListener('click', (e)=> {
         e.preventDefault();
        if (window.location.search.indexOf('?') > -1)
        {
           const cleanurl = window.location.href.split("?")[0];
           window.history.replaceState({}, document.title, cleanurl);
        }
       location.reload();
    })
}

if (contentsearchButton)
{
    contentsearchButton.addEventListener('click', (e) => {  
        GetContentResults();
    });
}

if (contentsearchButtonMobile)
{
    contentsearchButtonMobile.addEventListener('click', (e) => {  
        GetContentResults();
    });
}

if (contentsearchtext)
{
    contentsearchtext.addEventListener('keypress', (e) => {
        if (e.key === "Enter") {
            GetContentResults();
        }
    });
}

if (contentsearchtextmobile)
{
    contentsearchtextmobile.addEventListener('keypress', (e) => {
        if (e.key === "Enter") {
            GetContentResults();
        }
    });
}

if (newssearchButton)
{
    newssearchButton.addEventListener('click', (e) => {
        GetSearchResults();
    });
}

if (newsterm)
{
    newsterm.addEventListener('keypress', (e) => {
        if (e.key === "Enter") {
            GetSearchResults();
        }
    });
}

if (prevbtn)
{
    prevbtn.addEventListener('click', (e:Event) => fetchNewsItems(newsid, terms.join('|'), newssort, currentpage-1, newstermstring));
}

if (nextbtn)     
{
    nextbtn.addEventListener('click', (e:Event) => fetchNewsItems(newsid, terms.join('|'), newssort, currentpage+1, newstermstring));
}    

if (newspaginationlinkButton) {
    newspaginationlinkButton.forEach(button => {
        button.addEventListener('click', (e) => {
            const pageIndex = button.id.indexOf('-');
            currentpage =  parseInt(button.id.substring(pageIndex+1));
            fetchNewsItems(newsid, terms.join('|'), newssort, currentpage, newstermstring).then((res) => {
                console.log(res);
                totalPage = res;
            });
        });
    });
}

if (newscategoriesCheckBoxes) {
    if (resetnewscategories)
    {
        resetnewscategories.addEventListener('click', ()=> {
             if (window.location.search.indexOf('?') > -1)
             {
                const cleanurl = window.location.href.split("?")[0];
                window.history.replaceState({}, document.title, cleanurl);
             }
            location.reload();
           
        });
    }
  
    newscategoriesCheckBoxes.forEach(checkbox => {
        checkbox.addEventListener('click', (e) => {
            if (checkbox.checked)
            {
                terms.push(checkbox.value);
            }
            else
            {
                const index = terms.indexOf(checkbox.value, 0);
                if (index > -1) {
                    terms.splice(index, 1);
                }
            }
            if (newsCategory[0])
            {
                newsCategory[0].setAttribute("data-terms", terms.join('|'));
            }
            currentpage = 1;
            fetchNewsItems(newsid, terms.join('|'), newssort, currentpage, newstermstring);
            
        });
    });
}

window.onload = function() {
    CheckFilters(); 
  }

function CheckFilters(): void {
    if (newscategoriesCheckBoxes) {
        newscategoriesCheckBoxes.forEach(checkbox => {
            if (checkbox.checked)
            {
                terms.push(checkbox.value);
            }
            else
            {
                const index = terms.indexOf(checkbox.value, 0);
                if (index > -1) {
                    terms.splice(index, 1);
                }
            }
        });
        if (terms && terms.length > 0)
        {
            if (newsCategory[0])
            {
                newsCategory[0].setAttribute("data-terms", terms.join('|'));
            }
            fetchNewsItems(newsid, terms.join('|'), newssort, 1, newstermstring);
        }
    }
}

function GetSearchResults() {
    if (newsterm) {
        newstermstring = newsterm.value;
        terms = [];
        currentpage = 1;
        if (newsCategory[0]) {
            newsCategory[0].setAttribute("data-terms", '');
        }
        if (newscategoriesCheckBoxes) {
            newscategoriesCheckBoxes.forEach(checkbox => {
                checkbox.checked = false;
            });
        }
        fetchNewsItems(newsid, '', newssort, currentpage, newstermstring).then((res) => {
            totalPage = res;
        });
    }
}

function GetContentResults() {
    if (listingpageurl) {
        let url = listingpageurl.value;
        if (url) {
            if (contentsearchtext && contentsearchtext.value) {
                url = `${url}?q=${contentsearchtext.value}`;
            }
            else if (contentsearchtextmobile && contentsearchtextmobile.value) {
                url = `${url}?q=${contentsearchtextmobile.value}`;
            }
            window.location.href = url;
        }
    }
}
